const types = {
  FollowUpBoss: {
    name: 'Follow Up Boss',
    image: 'follow_up_boss.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://followupboss.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
    video: 'https://player.vimeo.com/video/245266733',
  },
  GoHighLevel: {
    name: 'Go High Level',
    image: 'high.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://www.gohighlevel.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  LionDesk: {
    name: 'Lion Desk (Deprecated)',
    image: 'lion_desk.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://liondesk.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  LionDeskV2: {
    name: 'Lion Desk (V2)',
    image: 'lion_desk.png',
    tokenType: 'Access Token',
    oauth: `https://api-v2.liondesk.com/oauth2/authorize?response_type=code&client_id=${process.env.LION_DESK_CLIENT_ID}&scope=read%20write&redirect_uri=${process.env.LION_DESK_OAUTH_CALLBACK}`,
    kind: 'CRM',
    url: 'https://liondesk.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  ProspectConverter: {
    name: 'Prospect Converter',
    image: 'prospect_converter.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://prospectconverter.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  Boomtown: {
    via: 'RealSynch',
    name: 'Boomtown',
    image: 'boomtown.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'http://www.boomtown.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  Salesforce: {
    via: 'RealSynch',
    name: 'Salesforce',
    image: 'salesforce.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://www.salesforce.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  Contactually: {
    via: 'RealSynch',
    name: 'Contactually',
    image: 'contactually.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://www.contactually.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
    hidden: true,
  },
  WiseAgent: {
    via: 'RealSynch',
    name: 'Wise Agent',
    image: 'wise_agent.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://wiseagent.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
    hidden: true,
  },
  RealGeeks: {
    via: 'RealSynch',
    name: 'Real Geeks',
    image: 'real_geeks.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'https://www.realgeeks.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  SierraInteractive: {
    via: 'RealSynch',
    name: 'Sierra Interactive',
    image: 'sierra_interactive.png',
    tokenType: 'API Key',
    kind: 'CRM',
    url: 'http://www.sierrainteractive.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  RealSynch: {
    hidden: false,
    name: 'Real Synch',
    image: 'realsynch.png',
    tokenType: 'API Key',
    kind: 'Middleware',
    url: 'http://www.realsynch.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
  },
  Slack: {
    name: 'Slack',
    image: 'slack.png',
    tokenType: 'Web Hook',
    kind: 'Messaging',
    url: 'https://slack.com',
    supports: ['New Leads', 'Messages', 'Search Activity', 'Realtime Updates'],
    video: 'https://player.vimeo.com/video/245793650',
  },
  Zapier: {
    name: 'Zapier',
    image: 'zapier.png',
    tokenType: '',
    kind: 'Middleware',
    url: 'https://zapier.com',
    supports: ['New Leads', 'Messages'],
  },
}

export default types


// WEBPACK FOOTER //
// client/components/sections/Integrations/types.js